import isEqual from "lodash.isequal";
import { useEffect, useState } from "react";
import type ImageSize from "~/models/image/ImageSize";
import getViewportDimensions from "./getViewportDimensions";
import isBrowser from "./isBrowser";

export default function useViewportSize() {
  const [dimensions, setDimensions] = useState<ImageSize | null>(null);

  useEffect(() => {
    let observer: ResizeObserver;

    if (isBrowser()) {
      observer = new ResizeObserver(() => {
        const newDimensions = getViewportDimensions();
        const didChange = !isEqual(dimensions, newDimensions);

        if (didChange) {
          setDimensions(newDimensions);
        }
      });
      observer.observe(document.documentElement);
    }

    return () => observer.disconnect();
  }, [dimensions, setDimensions]);

  return dimensions;
}
